// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { getSparseProjects } from '@/project/api/get-sparse-projects';
import { REFERENCE_DATA_QUERY_OPTIONS } from '@/utilities/query-profiles';
import { useQuery } from '@tanstack/react-query';

interface UseSparseProjectListOptions {
  // Defaults to true; pass false to suppress the fetch (e.g. when the
  // owning dialog is closed but the component is mounted).
  enabled?: boolean;
}

/**
 * A React hook that requests a lightweight collection of all projects from the remote API.
 * This hook is optimized for autocomplete components and dropdowns where only basic
 * project information is needed.
 */
export function useSparseProjectList(
  options: UseSparseProjectListOptions = {}
) {
  const enabled = options.enabled ?? true;
  const { data, isLoading, isFetching } = useQuery({
    queryKey: ['sparse-projects'],
    queryFn: getSparseProjects,
    ...REFERENCE_DATA_QUERY_OPTIONS,
    enabled,
  });

  return {
    projects: data?.projects ?? [],
    isLoading,
    isFetching,
  };
}
